import { FormProvider } from '@/context/FormProvider';

import {
  type ChangePasswordFormValues,
  changePasswordSchema,
  type InviteUserFormValues,
  inviteUserSchema,
  updateUserProfileSchema,
} from '@/schemas/user.schema';

export const InviteUserFormProvider = ({ children, onSubmit }) => {
  const initialValues: InviteUserFormValues = {
    users: [
      {
        email: '',
        role: undefined,
      },
    ],
  };

  return (
    <FormProvider
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={inviteUserSchema}
    >
      {children}
    </FormProvider>
  );
};

export const UpdateProfileFormProvider = ({ children, initialValues, onSubmit }) => {
  return (
    <FormProvider
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={updateUserProfileSchema}
    >
      {children}
    </FormProvider>
  );
};

export const ChangePasswordFormProvider = ({ children, onSubmit }) => {
  const initialValues: ChangePasswordFormValues = {
    current_password: '',
    new_password: '',
    confirm_new_password: '',
  };

  return (
    <FormProvider
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={changePasswordSchema}
    >
      {children}
    </FormProvider>
  );
};
